export const GET_SEARCH_RESULT = `
query SearchPostTypes($search: String!) {
  searchPosts(search: $search, numberOfPosts: 20) {
   exchange {
          ctaURL
          enName
          logo
          faName
          postType
          slug
          title
          uri
    }
   broker {
          ctaURL
          enName
          faName
          logo
          postType
          slug
          title
          uri
    }
   prop {
          ctaURL
          enName
          faName
          logo
          postType
          slug
          title
          uri
    }
   gold_platforms {
          ctaURL
          enName
          faName
          logo
          postType
          slug
          title
          uri
    }
  symbol {
      postType
      price
      slug
      title
      uri
      nameFa
      iconUrl
      sparkline
      usdt_price
      change
      typeId
    }
  gold {
      postType
      price
      slug
      title
      uri
      nameFa
      iconUrl
      sparkline
      usdt_price
      change
      typeId
    }
  currency {
      postType
      price
      slug
      title
      uri
      nameFa
      iconUrl
      sparkline
      usdt_price
      change
      typeId
    }
    news {
      featuredImage
      postType
      slug
      title
      uri
    }
      post {
      featuredImage
      postType
      slug
      title
      uri
    }
    analyses {
      title
      postType
      featuredImage
      slug
      uri
    }
  }
}
    `;
